export default __webpack_public_path__ + "static/media/loaf-bg.204288a3.png";